module.exports = __webpack_public_path__ + "static/img/dialog-bg.cb6ace7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/event/Christmas2020/dialog-bg.png
// module id = qP3Q
// module chunks = 1